import { forwardRef } from 'react';

import { imageMap } from '@/assets/img/imageMap';
import { type TicketRewardType } from '@/common/types/lottery';

import { CommonReward, type CommonRewardProps } from './CommonReward';
import { rewardsBgMap } from './config';
import { getRewardIconKey } from './lib';

interface RewardByTypeProps extends CommonRewardProps {
  type: 'tgem' | 'dice' | 'usd' | 'usdt' | TicketRewardType;
}

const RewardByType = forwardRef<
  HTMLDivElement,
  Omit<RewardByTypeProps, 'bgVariant' | 'icon'>
>(({ type, ...props }, ref) => {
  const bgVariant = rewardsBgMap[type];
  const iconKey = getRewardIconKey(type);
  const iconImages = imageMap[iconKey];

  return (
    <CommonReward
      {...props}
      icon={{
        img: iconImages.png,
        webp: iconImages.webp,
        alt: type,
        className: 'size-[80%]',
      }}
      bgVariant={bgVariant}
      ref={ref}
    />
  );
});

export { RewardByType };
